

          
          import _mopShowtimesPlaceholder_html_3561c8b1 from "swug:include:movie/shared/partials/_mopShowtimesPlaceholder.html"
          window.Fandango.templates = window.Fandango.templates || {};
          window.Fandango.templates._movieShowtimes = function anonymous(_swig,_ctx,_filters,_utils,_fn
) {
  var _imports = { _mopShowtimesPlaceholder_html_3561c8b1 };
  var _ext = _swig.extensions,
    _output = "";
_output += "<section class=\"js-movie-showtimes-content shared-showtimes__wrapper\">\n    ";
_output += (_imports["_mopShowtimesPlaceholder_html_3561c8b1"]?.(_swig, _filters, _utils, _fn) ?? _swig.compileFile("./_mopShowtimesPlaceholder.html", {resolveFrom: "app/views/movie/shared/partials/_movieShowtimes.html"}))(_ctx);
_output += "\n</section>\n";

  return _output;

}
          export default window.Fandango.templates._movieShowtimes;
          